import React, { Component } from 'react'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faUser, faCrown /*faBath*/, faBars,faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { animateScroll as scroll } from 'react-scroll';
import * as styles from './footermenu.module.css'

export default class Footermenu extends Component {

  scrollToTop = () => {
    scroll.scrollToTop(); 
  }

  render() {
    return (
      <div className={styles.footermenu}>
        <ul>
          <Link to={`/`} style={{width:`20%`}}>
            <li>
              <div><FontAwesomeIcon icon={faHome} /><p>ホーム</p></div>
            </li>
          </Link>
          <Link to={`/titifuckactress/`} style={{width:`20%`}}>
            <li>
              <div><FontAwesomeIcon icon={faUser} /><p>女優一覧</p></div>
            </li>
          </Link>
          <Link to={`/titifuckbest/`} style={{width:`20%`}}>
            <li>
              <div><FontAwesomeIcon icon={faCrown} /><p>ベスト作品</p></div>
            </li>
          </Link>
          <Link to={`/mobilemenu/`} style={{width:`20%`}}>
            <li>
              <div><FontAwesomeIcon icon={faBars} /><p>メニュー</p></div>
            </li>
          </Link>
          <li style={{ marginRight: `0`, width:`20%`, background: `#ff7f50` }} onClick={this.scrollToTop} role='presentation'>
            <div>
              <FontAwesomeIcon icon={faArrowUp} />
              <p>トップへ</p>
            </div>
          </li>
        </ul>
      </div>
    )
  }
}